import { Group, Switch } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import useFetch from '../../helpers/useFetch';

const PipelineStatus = ({ pipeline }) => {
  const { domain } = useSelector((state) => state.domain);
  const [running, setRunning] = useState(pipeline.running);
  const fetch = useFetch();

  const togglePipeline = (running) => {
    fetch(`/api/admin/accounts/${domain.accountId}/domains/${domain.id}/pipelines/${pipeline.id}`, {
      method: 'PUT',
      body: JSON.stringify({ running }),
    })
      .then(() => setRunning(running))
      .catch((e) => {
        notifications.show({
          title: 'Error while saving!',
          message: e?.message,
          color: 'danger',
        });
      });
  };

  return (
    <Group justify="flex-end">
      <Switch size="lg" checked={running} onChange={(e) => togglePipeline(e.target.checked)} />
    </Group>
  );
};

export default PipelineStatus;
